import http from 'axios'
import { cancelAllRequests, refreshToken } from '@/utils/axios-helper'

const cancelToken = http.CancelToken
let cancelSource

export default {
  searchTiers: (query, pageable) => {
    if (cancelSource) {
      cancelAllRequests()
      refreshToken()
      cancelSource.cancel(`Annule l'ancienne recherche avant une nouvelle recherche`)
    }
    cancelSource = cancelToken.source()

    let pageableParams = pageable.page ? `&page=${pageable.page}` : ''
    pageableParams += pageable.size ? `&size=${pageable.size} ` : ''
    pageableParams += pageable.sort ? `&sort=${pageable.sort}` : ''
    return http.get(`/web/v1/adherents?queryTiers=${encodeURIComponent(query)}${pageableParams}`, { cancelToken: cancelSource.token })
  },
  getTiers: (username) => {
    return http.get(`/web/v1/${username}`)
  }
}
